<template>
	<div class="jikao-container">
		<div class="inner-container">
			<!-- Left Content: Exam Title -->
			<div class="main-content-wrapper">
				<div class="exam-wrapper" ref="examWrap">
					<!-- 注意事项模块 -->
					<div v-if="showNotice" class="zhuyishixiang-container">
						<div class="content-wrapper">
							<div class="notice-box">
								<div class="notice-title">注意事项</div>
								<div class="notice-content">
									<p>1.听力考试由A、B两套试卷组成，每套试卷各20小题，满分均为30分。考生须依次完成两套试卷作答。</p>
									<p>2.注意，回答听力部分时，可以将答案记录在草稿纸上，每套试卷听力播放全部结束后，你将有2分钟的时间将你的答案录入计算机，并进行确认和修改。</p>
									<p>3.听力考试过程中，如出现播放不清、设备故障等，请立即举手向工作人员示意。</p>
								</div>
								<div class="notice-footer">
									祝各位考生考试顺利！
								</div>
							</div>
						</div>
					</div>
					<!-- A卷结尾展示 -->
					<div class="exam-header" v-if="showAPaperEnd && !showNotice">
						<div class="exam-title-card">
							<div class="exam-title">A卷作答完成，答案上传成功</div>
							<div class="exam-subtitle">请您休息并等待B卷考核</div>
						</div>
					</div>
					<!-- 节点1: 片头 -->
					<div class="exam-header" v-if="examNodeCurrent === 1 && !showNotice && !showAPaperEnd">
						<div class="exam-title-card">
							<div class="exam-title">{{ examTitle }}</div>
							<div class="exam-subtitle">{{ currentPaper === 'B' ? '英语听力试卷B' : '英语听力试卷A' }}</div>
						</div>
					</div>
					<!-- 节点2-3: 第一节 -->
					<div class="section-content" v-if="examNodeCurrent >= 2 && examNodeCurrent <= 3 && !showAPaperEnd">
						<div class="section-title">第一节</div>
						<div class="instruction-box">
							听下面5段录音。每段录音后有一个小题，从题中所给的A、B、C三个选项中选出最佳选项。听完每段录音后，你都有10秒钟的时间来回答有关小题和阅读下一小题。每段录音播放两遍。</div>
						<!-- 节点3显示题目 -->
						<template v-if="examNodeCurrent === 3">
							<div class="kaoshiXtim" v-for="(item, index) in exam.slice(0, 5)" :key="index">
								<div class="kaoshiT" v-for="(a, b) in getSmallQuestions(item)" :key="b"
									:id="getQuestionAnchorId(a.num)"
									:class="{ 'is-active-question': a.num === activeQuestionNum }">
									<div class="kaoshiWt">
										<div class="kaoshiDa">
											<i>(</i>
											<span>{{ a.selected }}</span>
											<i>)</i>
										</div>
										{{ a.num }}、{{ a.title }}
									</div>
									<div class="kaoshiXx">
										<p :class="{ active: a.selected == i.number }"
											v-for="(i, s) in getSmallQuestionOptions(a)" :key="s" @click="daBtn(a, i)">
											{{ i.number }}、{{ i.content }}
										</p>
									</div>
								</div>
							</div>
						</template>
					</div>
					<!-- 节点4-14: 第二节 -->
					<div class="section-content" v-if="examNodeCurrent >= 4 && examNodeCurrent <= 14 && !showAPaperEnd">
						<div class="section-title">第二节</div>
						<div class="instruction-box">
							听下面5段录音。每段录音后有几个小题，从题中所给的A、B、C三个选项中选出最佳选项。听每段录音前，你将有时间阅读各个小题，每小题5秒钟;听完后，每小题都有5秒钟的作答时间。每段录音播放两遍。
						</div>
						<div class="kaoshiXtim" v-if="Math.floor((examNodeCurrent - 5) / 2) == index"
							v-for="(item, index) in exam.slice(5)" :key="index">
							<h4 class="kaoshiH">
								听第{{ 6 + index }}段录音，回答第{{ getQuestionRangeText(item) }}题。
							</h4>
							<div class="kaoshiT" v-if="examNodeCurrent == (index * 2) + 6"
								v-for="(a, b) in getSmallQuestions(item)" :key="b" :id="getQuestionAnchorId(a.num)"
								:class="{ 'is-active-question': a.num === activeQuestionNum }">
								<div class="kaoshiWt">
									<div class="kaoshiDa">
										<i>(</i>
										<span>{{ a.selected }}</span>
										<i>)</i>
									</div>
									{{ a.num }}、{{ a.title }}
								</div>
								<div class="kaoshiXx">
									<p :class="{ active: a.selected == i.number }"
										v-for="(i, s) in getSmallQuestionOptions(a)" :key="s" @click="daBtn(a, i)">
										{{ i.number }}、{{ i.content }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="bottom-bar">
					<div v-if="false" class="debug-toggle" @click="showDebugAudioBar = !showDebugAudioBar" title="切换调试模式">
						<i :class="showDebugAudioBar ? 'el-icon-close' : 'el-icon-s-tools'"></i>
					</div>
					<div class="indicate-box">
						<div class="indicate-light" :class="{ 'is-red': Number(volume) === 0 }"></div>
						<div class="indicate-text-box">
							
							<div class="indicate-text" v-if="currentIndicateType === 3"></div>
							<div class="indicate-text" v-else-if="currentIndicateType === 1">听指令</div>
							<div class="indicate-text" v-else-if="currentIndicateType === 2 && countDown > -1 && remaining > 0">{{ countDown }}s</div>
						</div>
					</div>

					<div class="audio-wave" ref="waveWrap">
						<canvas class="audio-wave-canvas" ref="waveCanvas"></canvas>
					</div>

					<div class="debug-panel" v-show="showDebugAudioBar">
						<div class="debug-controls">
							<el-radio-group v-model="currentPaper" size="mini" @change="handleDebugPaperChange"
								fill="#0066cc">
								<el-radio-button label="A">A卷</el-radio-button>
								<el-radio-button label="B">B卷</el-radio-button>
							</el-radio-group>
							<div class="node-info">
								<span class="node-id">#{{ examNodeCurrent }}</span>
							</div>
							<el-button class="debug-end-btn" size="mini" type="danger"
								@click="finishExam">结束考试(调试)</el-button>
						</div>
						<div class="debug-slider-row">
							<span class="time-label">{{ currentAudioIndex + 1 }}/{{ audioList.length }}</span>
							<el-slider v-model="currentAudioIndex" :min="0"
								:max="audioList.length > 0 ? audioList.length - 1 : 0"
								:format-tooltip="formatDebugTooltip" @change="handleDebugAudioChange" size="mini"
								class="debug-slider"></el-slider>
						</div>
					</div>
				</div>
			</div>

			<!-- Right Sidebar -->
			<div class="sidebar">
				<div class="sidebar-header">
					<div class="header-item">
						<div class="label">考生</div>
					</div>
					<div class="header-item">
						<div class="label">机位</div>
					</div>
				</div>

				<div class="user-seat-panel">
					<div class="seat-box avatar-box">
						<img v-if="infoData.avatar" :src="$imgUrl + infoData.avatar" class="seat-avatar-img" />
						<div v-else class="seat-avatar-placeholder">
							<i class="el-icon-user-solid"></i>
						</div>
					</div>
					<div class="seat-box number-box">
						<div class="seat-number">{{ seatNumber }}</div>
					</div>
				</div>

				<div class="user-info">
					<div class="info-group">
						<div class="info-label">姓名</div>
						<div class="info-value name">{{ infoData.nickName }}</div>
					</div>
					<div class="info-group">
						<div class="info-label">准考证号</div>
						<div class="info-value ticket">{{ infoData.phonenumber }}</div>
					</div>
					<div class="info-divider"></div>
				</div>

				<!-- Question Card -->
				<div class="question-card" v-if="!showNotice">
					<div class="card-content">
						<div class="section-group">
							<div class="section-header">
								<span class="section-name">第一节</span>
								<div class="show-answer" @click="toggleCardAnswerDisplay">
									<i class="el-icon-refresh"></i> {{ showCardAnswer ? '隐藏答案' : '显示答案' }}
								</div>
							</div>
							<div class="question-grid">
								<div v-for="n in 5" :key="n" class="question-item" :class="getCardItemClass(n)"
									@click="handleCardClick(n)">{{ getCardDisplayText(n) }}</div>
							</div>
						</div>

						<div class="section-group">
							<div class="section-header">
								<span class="section-name">第二节</span>
							</div>
							<div class="question-grid">
								<div v-for="n in 15" :key="n + 5" class="question-item" :class="getCardItemClass(n + 5)"
									@click="handleCardClick(n + 5)">{{ getCardDisplayText(n + 5) }}</div>
							</div>
						</div>
					</div>

					<div class="card-footer">
						<span class="paper-type">{{ currentPaper }}卷</span>
						<span class="status-text">
							<i :class="cardStatusIconClass"></i> {{ cardStatusText }}
						</span>
					</div>
				</div>

				<div class="volume-control">
					<div class="volume-label">音量调节</div>
					<div class="slider-wrapper">
						<img src="@/assets/svg/volume_icon.svg" alt="volume" class="volume-icon" />
						<el-slider v-model="volume" :min="0" :max="100" @change="handleVolumeChange"></el-slider>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { audioNodeMapping } from '@/page/jikao/audioNodeMapping.js';
import { mapState } from 'vuex';
const AUDIO_VOLUME_STORAGE_KEY = 'jikaoAudioVolume';
const SEAT_NUMBER_STORAGE_KEY = 'jikaoSeatNumber';
export default {
	name: 'jikao',
	data() {
		return {
			seatNumber: 50,
			examQuery: null,
			volume: 50,
			isStepPanelVisible: false,
			isExamFinished: false,
			finishTimer: null,
			isEndPage: false,
			endTimer: null,
			autoSubmitDone: false,
			autoSubmitFailed: false,
			currentPaper: 'A',
			exam: [],
			examNodeCurrent: 1,
			isAudioPlaying: false,
			showDebugAudioBar: false,
			// 多段音频播放相关
			currentAudioIndex: 0,
			audioList: [],
			audioNodeMap: audioNodeMapping,
			activeQuestionNum: null,
			maxUnlockedQuestionNum: 0,
			autoFollowAudioNode: true,
			lastAutoFollowAudioNode: null,
			examResultDetailQuery: null,
			examTitle: '',
			// 注意事项模块相关
			showNotice: false,
			confirmAudioList: [],
			confirmExamData: null,
			countDown: '-1',
			remaining: '',
			showCardAnswer: false
		};
	},
	computed: {
		...mapState(['infoData']),
		currentAudioMapping() {
			const idx = Number(this.currentAudioIndex);
			if (!Number.isFinite(idx)) return null;
			const map = Array.isArray(this.audioNodeMap) ? this.audioNodeMap : [];
			return map.find(m => m && Number(m.audioIdx) === idx) || null;
		},
		showAPaperEnd() {
			return this.currentPaper === 'A' && this.isAnswerLocked;
		},
		isAnswerLocked() {
			const idx = Number((this.currentAudioMapping && this.currentAudioMapping.audioIdx) ?? this.currentAudioIndex);
			return Number.isFinite(idx) && idx >= 89;
		},
		currentIndicateType() {
			const v = Number(this.currentAudioMapping && this.currentAudioMapping.indicateType);
			if (v === 1 || v === 2 || v === 3) return v;
			if (v === 0) return 3;
			return 3;
		},
		cardStatusText() {
			if (this.isExamFinished) return '作答完成';
			if (this.isAnswerLocked) return '答案已上传';
			const idx = Number((this.currentAudioMapping && this.currentAudioMapping.audioIdx) ?? this.currentAudioIndex);
			if (Number.isFinite(idx) && idx >= 87) return '准备上传中';
			return '正在作答中';
		},
		isCardUploading() {
			if (this.isExamFinished) return false;
			const idx = Number((this.currentAudioMapping && this.currentAudioMapping.audioIdx) ?? this.currentAudioIndex);
			return Number.isFinite(idx) && idx >= 87;
		},
		cardStatusIconClass() {
			return this.isCardUploading ? 'el-icon-upload' : 'el-icon-edit-outline';
		}
	},
	watch: {
		showDebugAudioBar(val) {
			// 切换调试面板时，如果正在播放，波形会自动切换显示模式
			// 不需要停止/启动，因为波形始终在运行
		},
		// 监听音频索引变化，更新展示节点
		currentAudioIndex(newIndex, oldIndex) {
			this.updateUnlockedAfterIndexChange(newIndex, oldIndex);
			this.updateExamNodeByAudioIndex(newIndex);
		}
	},
	created() {
		this._autoplayUnlockFn = null;
		this._autoplayUnlockNotified = false;
		this._pendingAutoplaySrc = null;
		this._pendingAutoplayEnded = null;
		this._audioEventHandlers = null;
		this._papers = null;
		this._autoSubmitPromise = null;
		this._jumpingToZj = false;
		this._countDownTimer = null;
		this._noticeFlowStarted = false; // 添加标志位防止重复执行
		this._wave = {
			rafId: null,
			running: false,
			pendingStart: false,
			ro: null,
			onResize: null,
			cssW: 0,
			cssH: 0,
			dpr: 1,
			ctx2d: null,
			timeData: null,
			freqData: null,
			rmsSmoothed: 0
		};
		this.initExamQuery();
		this.ensurePaperConfigs();
	},
	mounted() {
		console.log('[jikao] mounted 被调用, _noticeFlowStarted =', this._noticeFlowStarted);
		this.initExamQuestionNums();
		this.syncSavedVolume();
		this.handleVolumeChange(this.volume);
		this.getSeatNumber();
		// 首次加载时启动注意事项流程
		if (!this._noticeFlowStarted) {
			this._noticeFlowStarted = true;
			console.log('[jikao] mounted 中启动 startNoticeFlow');
			this.startNoticeFlow();
		}
		this.$nextTick(() => {
			this.bindWaveResizeObserver();
			this.ensureWaveCanvasSize();
			this.drawWaveIdle();
			if (this.isAudioPlaying || (this._wave && this._wave.pendingStart)) {
				this.startWave();
			}
		});
	},
	activated() {
		console.log('[jikao] activated 被调用, _noticeFlowStarted =', this._noticeFlowStarted);
		this.initExamQuestionNums();
		this.syncSavedVolume();
		this.handleVolumeChange(this.volume);
		// 只在首次激活且未启动过时才执行
		if (!this._noticeFlowStarted) {
			this._noticeFlowStarted = true;
			console.log('[jikao] activated 中启动 startNoticeFlow');
			this.startNoticeFlow();
		}
		this.$nextTick(() => {
			this.bindWaveResizeObserver();
			this.ensureWaveCanvasSize();
			this.drawWaveIdle();
			if (this.isAudioPlaying || (this._wave && this._wave.pendingStart)) {
				this.startWave();
			}
		});
	},
	deactivated() {
		this.stopAudio();
	},
	beforeDestroy() {
		this.stopAudio();
	},
	methods: {
		normalizeMediaUrl(url) {
			if (!url) return '';
			
			let s = String(url).trim();
			if (!s) return '';
			
			// 移除反引号
			if (s.startsWith('`')) s = s.slice(1);
			if (s.endsWith('`')) s = s.slice(0, -1);
			s = s.trim();
			
			// 已经是完整URL
			if (/^https?:\/\//i.test(s) || s.startsWith('//') || 
				s.startsWith('blob:') || s.startsWith('data:')) {
				return s;
			}
			
			// 拼接基础URL
			const base = this.$imgUrl || '';
			if (!base) return s;
			
			if (s.startsWith('/')) return `${base}${s}`;
			return `${base}/${s}`;
		},
		confirmExam(nodeType) {
			if (!this.examQuery) return Promise.resolve(null);
			
			const payload = {
				...this.examQuery,
				nodeType: Number(nodeType)
			};
			
			return this.$http
				.post('api/app/yydComputerizedExamPaper/confirmExam', payload)
				.then((res) => {
					if (res?.code !== 0 && res?.code !== 200) return null;
					
					this.confirmExamData = res?.data || null;
					
					// 提取并规范化音频URL
					const audios = Array.isArray(this.confirmExamData?.audios) 
						? this.confirmExamData.audios 
						: [];
					
					this.confirmAudioList = audios
						.map(a => this.normalizeMediaUrl(a && a.url))
						.filter(Boolean);
					
					return this.confirmExamData;
				})
				.catch(() => null);
		},
		initExamQuery() {
			const q = (this.$route && this.$route.query) ? this.$route.query : {};
			const toInt = (v) => {
				if (v === undefined || v === null || v === '') return null;
				const n = Number(v);
				return Number.isFinite(n) ? n : null;
			};
			const toLong = (v) => {
				const n = toInt(v);
				if (n === null) return null;
				if (n <= 0) return null;
				return n;
			};
			const examQuery = {
				classification: toInt(q.classification),
			};

			if (examQuery.classification === 1) {
				examQuery.paperAId = toLong(q.paperAId);
				examQuery.sourceA = toInt(q.sourceA);
				examQuery.paperBId = toLong(q.paperBId);
				examQuery.sourceB = toInt(q.sourceB);
			} else if (examQuery.classification === 2) {
				examQuery.paperId = toLong(q.paperId);
			}

			const isValid =
				(examQuery.classification === 1 || examQuery.classification === 2) && (
					(
						Number.isFinite(examQuery.paperAId) &&
						Number.isFinite(examQuery.paperBId) &&
						(examQuery.sourceA === 1 || examQuery.sourceA === 2 || examQuery.sourceA === 3) &&
						(examQuery.sourceB === 1 || examQuery.sourceB === 2 || examQuery.sourceB === 3)
					) || (
						Number.isFinite(examQuery.paperId)
					)
				)
				;

			if (!isValid) {
				this.examQuery = null;
				return;
			}

			this.examQuery = examQuery;
		},
		requestConfirmExam(nodeType) {
			if (!this.examQuery) return Promise.resolve(null);
			
			const nt = Number(nodeType);
			const target = nt === 3 ? 'B' : (nt === 2 ? 'A' : null);
			
			// 检查是否已经有缓存的试卷数据
			if (target && this._papers && this._papers[target]) {
				const cached = this._papers[target];
				if (cached.exam && cached.exam.length > 0 && cached.audioList && cached.audioList.length > 0) {
					console.log(`使用已缓存的${target}卷数据`);
					// 使用缓存的数据
					if (this.currentPaper === target) {
						this.exam = cached.exam;
						this.audioList = cached.audioList;
						this.examTitle = cached.title || '';
						this.initExamQuestionNums(this.exam);
					}
					return Promise.resolve({ code: 200, data: cached });
				}
			}
			
			this.examTitle = ''
			const payload = {
				...this.examQuery,
				nodeType: Number(nodeType)
			};
			return this.$http
				.post('api/app/yydComputerizedExamPaper/confirmExam', payload)
				.then((res) => {
					const rawTitle = res && res.data && res.data.title !== undefined ? res.data.title : '';
					const title = rawTitle === null ? '' : String(rawTitle);
					this.examTitle = title;
					const audios = Array.isArray(res && res.data && res.data.audios) ? res.data.audios : null;
					console.log('audios',audios)
					let audioList = [];
					if (audios) {
						audioList = audios
							.map((a) => {
								const rawUrl = a && a.url !== undefined ? a.url : '';
								let url = rawUrl === null ? '' : String(rawUrl);
								url = url.trim();
								if (url.startsWith('`')) url = url.slice(1);
								if (url.endsWith('`')) url = url.slice(0, -1);
								url = url.trim();
								return {
									fileId: a && a.fileId,
									name: a && a.name,
									url
								};
							})
							.filter((a) => a && a.url);
						this.audioList = audioList;
					}
					
					const questionsRaw = res && res.data ? res.data.questions : null;
					const questions = Array.isArray(questionsRaw) ? questionsRaw.filter(q => q && typeof q === 'object') : null;
					if (questions) {
						this.ensurePaperConfigs();
						const nt = Number(nodeType);
						const target = nt === 3 ? 'B' : (nt === 2 ? 'A' : (this.currentPaper === 'B' ? 'B' : 'A'));
						if (this._papers && this._papers[target]) {
							// 缓存试卷数据、音频列表和标题
							this._papers[target].exam = questions;
							this._papers[target].audioList = audioList;
							this._papers[target].title = title;
							
							if (this.currentPaper === target) {
								this.exam = this._papers[target].exam;
								this.initExamQuestionNums(this.exam);
							}
						}
					}
					return res;
				})
				.catch(() => null);
		},
		requestConfirmExamForPaper(paper) {
			const p = paper === 'B' ? 'B' : 'A';
			const nodeType = p === 'A' ? 2 : 3;
			return this.requestConfirmExam(nodeType);
		},
		buildSubmitExamPayload() {
			this.ensurePaperConfigs();
			const paperA = this._papers && this._papers.A ? this._papers.A.exam : (this.currentPaper === 'A' ? this.exam : []);
			const paperB = this._papers && this._papers.B ? this._papers.B.exam : (this.currentPaper === 'B' ? this.exam : []);
			return {
				...(this.examQuery || {}),
				paperA,
				paperB
			};
		},
		submitExam() {
			const payload = this.buildSubmitExamPayload();
			return this.$http
				.post('api/app/yydComputerizedExamPaper/submitExam', payload)
				.then((res) => {
					if (res && res.data) {
						const examResultDetailQuery = {
							paperId: res.data.paperId || '',
							recordId: res.data.recordId || '',
							...this.examQuery
						};

						this.examResultDetailQuery = examResultDetailQuery;
					}
					return res;
				})
				.catch(() => null);
		},
		ensurePaperConfigs() {
			if (this._papers) return;
			const examA = [];
			const examB = [];
			this._papers = {
				A: { exam: examA, audioList: [], title: '' },
				B: { exam: examB, audioList: [], title: '' }
			};
		},
		setPaper(paper, opts) {
			this.ensurePaperConfigs();
			const p = paper === 'B' ? 'B' : 'A';
			const conf = this._papers && this._papers[p] ? this._papers[p] : null;
			this.currentPaper = p;
			this.showCardAnswer = false;
			
			if (conf) {
				this.exam = conf.exam;
				// 如果已经有缓存的音频列表和标题，直接使用
				if (conf.audioList && conf.audioList.length > 0) {
					this.audioList = conf.audioList;
				}
				if (conf.title) {
					this.examTitle = conf.title;
				}
			}
			
			const o = opts && typeof opts === 'object' ? opts : {};
			if (o.resetAudioState !== false) {
				this.examNodeCurrent = 1;
				this.currentAudioIndex = 0;
				this.maxUnlockedQuestionNum = 0;
				this.activeQuestionNum = null;
				this.autoFollowAudioNode = true;
				this.lastAutoFollowAudioNode = null;
			}
			this.initExamQuestionNums(this.exam);
			
			// 检查是否已经有完整的缓存数据
			if (conf && conf.exam && conf.exam.length > 0 && conf.audioList && conf.audioList.length > 0) {
				console.log(`${p}卷数据已缓存，无需重新请求`);
				return Promise.resolve({ code: 200, data: conf });
			}
			
			return this.requestConfirmExamForPaper(p);
		},
		// 播放当前试卷的音频列表
		playCurrentPaperAudio() {
			this.currentAudioIndex = 0;
			this.maxUnlockedQuestionNum = 0;
			this.activeQuestionNum = null;
			this.autoFollowAudioNode = true;
			this.lastAutoFollowAudioNode = null;
			this.playAudioByIndex(0);
		},
		// 根据索引播放音频
		playAudioByIndex(index) {
			if (index >= this.audioList.length) {
				this.stopCountDown();
				// 当前试卷所有音频播放完成
				if (this.currentPaper === 'A') {
					const p = this.setPaper('B');
					Promise.resolve(p).finally(() => {
						this.playCurrentPaperAudio();
					});
				} else {
					this.finishExam();
				}
				return;
			}
			this.currentAudioIndex = index;
			const audioFile = this.audioList[index];
			// 更新展示节点
			this.updateExamNodeByAudioIndex(index);
			const indicateType = this.getIndicateTypeByAudioIndex(index);
			if (indicateType === 2) this.startCountDown();
			else this.stopCountDown();
			
			// 播放音频
			this.bindAudioEvents();
			this.playSrc(audioFile.url, () => {
				this.updateUnlockedAfterAudioEnded(index);
				this.stopCountDown();
				// 音频播放完成回调，播放下一段
				this.playAudioByIndex(index + 1);
			});
		},
		getIndicateTypeByAudioIndex(audioIndex) {
			const idx = Number(audioIndex);
			if (!Number.isFinite(idx)) return 3;
			const map = Array.isArray(this.audioNodeMap) ? this.audioNodeMap : [];
			const found = map.find(m => m && Number(m.audioIdx) === idx);
			const v = Number(found && found.indicateType);
			if (v === 1 || v === 2 || v === 3) return v;
			if (v === 0) return 3;
			return 3;
		},
		getAudioNodeByIndex(audioIndex) {
			const idx = Number(audioIndex);
			if (!Number.isFinite(idx)) return null;
			const map = Array.isArray(this.audioNodeMap) ? this.audioNodeMap : [];
			const found = map.find(m => m && m.audioIdx === idx);
			if (found && found.node !== undefined) return found.node;
			return null;
		},
		updateUnlockedAfterAudioEnded(audioIndex) {
			const idx = Number(audioIndex);
			if (!Number.isFinite(idx)) return;
			const nodeNow = this.getAudioNodeByIndex(idx);
			if (nodeNow === null) return;
			const nodeNext = this.getAudioNodeByIndex(idx + 1);
			if (nodeNext !== null && Number(nodeNext) === Number(nodeNow)) return;
			const r = this.getNavigableRangeByAudioNode(nodeNow);
			if (!r) return;
			const max = Number(r.max);
			if (!Number.isFinite(max)) return;
			this.maxUnlockedQuestionNum = Math.max(Number(this.maxUnlockedQuestionNum) || 0, max);
		},
		updateUnlockedAfterIndexChange(newIndex, oldIndex) {
			const n = Number(newIndex);
			const o = Number(oldIndex);
			if (!Number.isFinite(n) || !Number.isFinite(o)) return;
			if (n !== o + 1) return;
			const nodeNow = this.getAudioNodeByIndex(o);
			if (nodeNow === null) return;
			const nodeNext = this.getAudioNodeByIndex(n);
			if (nodeNext !== null && Number(nodeNext) === Number(nodeNow)) return;
			const r = this.getNavigableRangeByAudioNode(nodeNow);
			if (!r) return;
			const max = Number(r.max);
			if (!Number.isFinite(max)) return;
			this.maxUnlockedQuestionNum = Math.max(Number(this.maxUnlockedQuestionNum) || 0, max);
		},
		// 根据音频索引更新展示节点
		updateExamNodeByAudioIndex(audioIndex) {
			if (!this.autoFollowAudioNode) return;
			const idx = Number(audioIndex);
			if (!Number.isFinite(idx)) return;
			const mapping = this.audioNodeMap.find(m => m && m.audioIdx === idx);
			if (!mapping) return;
			const node = mapping.node;
			if (node === undefined || node === null) return;
			if (Number(this.lastAutoFollowAudioNode) === Number(node)) return;
			this.examNodeCurrent = node;
			this.lastAutoFollowAudioNode = node;
		},
		resetAutoSubmitState() {
			this.autoSubmitDone = false;
			this.autoSubmitFailed = false;
			this._autoSubmitPromise = null;
		},
		autoSubmitExam() {
			if (this._autoSubmitPromise) return this._autoSubmitPromise;
			if (this.autoSubmitDone) return Promise.resolve(null);
			if (!this.examQuery) {
				this.autoSubmitDone = true;
				this.autoSubmitFailed = true;
				return Promise.resolve(null);
			}
			const loading = this.$loading ? this.$loading({
				lock: true,
				text: '交卷中，请稍后...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			}) : null;
			this._autoSubmitPromise = this.submitExam()
				.then((res) => {
					this.autoSubmitDone = true;
					const ok = !!(res && (res.code === 0 || res.code === 200));
					this.autoSubmitFailed = !ok;
					
					// 只在这里统一处理提示，避免重复
					if (this.$message) {
						if (ok) {
							this.$message.success('交卷成功');
						}
					}
					
					if (ok) {
						this.$router.push({
							path: '/jikaoJs',
							query: this.examResultDetailQuery
						}).catch(err => {
							// 只在真正的导航错误时提示，忽略重复导航等非错误情况
							if (err && err.name !== 'NavigationDuplicated') {
								console.error('Navigation failed:', err);
							}
						});
					}
					return res;
				})
				.catch((err) => {
					// 这里捕获的是submitExam之外的异常（理论上不应该发生）
					console.error('Unexpected error in autoSubmitExam:', err);
					this.autoSubmitDone = true;
					this.autoSubmitFailed = true;
					// 不再弹提示，因为.then中已经处理过了
					return null;
				})
				.finally(() => {
					if (loading && typeof loading.close === 'function') {
						loading.close();
					}
				});
			return this._autoSubmitPromise;
		},
		finishExam() {
			if (this.isExamFinished) return;
			this.isExamFinished = true;
			this.examNodeCurrent = -1;
			this.autoSubmitExam();
		},
		initExamQuestionNums(examData) {
			let num = 1;
			const src = examData || this.exam;
			const list = Array.isArray(src) ? src : [];
			list.forEach(item => {
				const smallRaw = item && (item.smallQuestions || item.yydSmallQuestionList);
				const smallList = Array.isArray(smallRaw) ? smallRaw : [];
				if (!Array.isArray(smallList)) return;
				smallList.forEach(i => {
					if (!i) return;
					if (Object.prototype.hasOwnProperty.call(i, 'num')) {
						i.num = num;
					} else if (this.$set) {
						this.$set(i, 'num', num);
					} else {
						i.num = num;
					}
					if (Object.prototype.hasOwnProperty.call(i, 'selected')) {
						i.selected = '';
					} else if (this.$set) {
						this.$set(i, 'selected', '');
					} else {
						i.selected = '';
					}
					num++;
				});
			});
		},
		getSmallQuestions(item) {
			const list = item && (item.smallQuestions || item.yydSmallQuestionList);
			return Array.isArray(list) ? list : [];
		},
		getSmallQuestionOptions(question) {
			const list = question && (question.options || question.yydSmallQuestionOptionList);
			return Array.isArray(list) ? list : [];
		},
		daBtn(question, option) {
			if (this.isAnswerLocked) return;
			if (!question || typeof question !== 'object') return;
			const raw = option && option.number !== undefined ? option.number : '';
			const number = raw === null ? '' : String(raw).trim();
			const nextVal = question.selected === number ? '' : number;
			if (question && question.num !== undefined && question.num !== null) {
				this.activeQuestionNum = question.num;
			}
			if (Object.prototype.hasOwnProperty.call(question, 'selected')) {
				question.selected = nextVal;
			} else if (this.$set) {
				this.$set(question, 'selected', nextVal);
			} else {
				question.selected = nextVal;
			}
		},
		getQuestionRangeText(item) {
			const list = this.getSmallQuestions(item);
			if (list.length <= 0) return '';
			if (list.length > 2) return `${list[0].num}至${list[list.length - 1].num}`;
			return list.map((i) => i && i.num).filter(Boolean).join('、');
		},
		getQuestionAnchorId(num) {
			const n = Number(num);
			if (!Number.isFinite(n) || n <= 0) return '';
			return `q-${n}`;
		},
		getSection1Range() {
			const list = Array.isArray(this.exam) ? this.exam.slice(0, 5) : [];
			let min = null;
			let max = null;
			list.forEach((item) => {
				this.getSmallQuestions(item).forEach((q) => {
					const n = Number(q && q.num);
					if (!Number.isFinite(n)) return;
					min = min === null ? n : Math.min(min, n);
					max = max === null ? n : Math.max(max, n);
				});
			});
			if (min === null || max === null) return null;
			return { min, max, node: 3 };
		},
		getSection2Ranges() {
			const list = Array.isArray(this.exam) ? this.exam.slice(5) : [];
			const ranges = [];
			list.forEach((item, idx) => {
				let min = null;
				let max = null;
				this.getSmallQuestions(item).forEach((q) => {
					const n = Number(q && q.num);
					if (!Number.isFinite(n)) return;
					min = min === null ? n : Math.min(min, n);
					max = max === null ? n : Math.max(max, n);
				});
				if (min === null || max === null) return;
				ranges.push({ min, max, node: idx * 2 + 6 });
			});
			return ranges;
		},
		getNodeByQuestionNum(num) {
			const n = Number(num);
			if (!Number.isFinite(n) || n <= 0) return null;
			const r1 = this.getSection1Range();
			if (r1 && n >= r1.min && n <= r1.max) return r1.node;
			const r2 = this.getSection2Ranges().find(r => n >= r.min && n <= r.max);
			return r2 ? r2.node : null;
		},
		getCurrentAudioNode() {
			const idx = Number(this.currentAudioIndex);
			const map = Array.isArray(this.audioNodeMap) ? this.audioNodeMap : [];
			const found = map.find(m => m && m.audioIdx === idx);
			if (found && found.node !== undefined) return found.node;
			return this.examNodeCurrent;
		},
		getNavigableRangeByAudioNode(node) {
			const n = Number(node);
			if (!Number.isFinite(n)) return null;
			if (n === 3) return this.getSection1Range();
			const ranges = this.getSection2Ranges();
			return ranges.find(r => r.node === n) || null;
		},
		isQuestionNavigable(num) {
			if (this.isExamFinished) return false;
			const n = Number(num);
			if (!Number.isFinite(n)) return false;
			const unlockedMax = Number(this.maxUnlockedQuestionNum);
			if (Number.isFinite(unlockedMax) && unlockedMax > 0 && n <= unlockedMax) return true;
			const r = this.getNavigableRangeByAudioNode(this.getCurrentAudioNode());
			if (!r) return false;
			return n >= r.min && n <= r.max;
		},
		findSmallQuestionByNum(num) {
			const n = Number(num);
			if (!Number.isFinite(n) || n <= 0) return null;
			const list = Array.isArray(this.exam) ? this.exam : [];
			for (let i = 0; i < list.length; i++) {
				const item = list[i];
				const qs = this.getSmallQuestions(item);
				for (let j = 0; j < qs.length; j++) {
					const q = qs[j];
					if (Number(q && q.num) === n) return q;
				}
			}
			return null;
		},
		isQuestionAnswered(num) {
			const q = this.findSmallQuestionByNum(num);
			return !!(q && q.selected);
		},
		getCardDisplayText(num) {
			const n = Number(num);
			if (!this.showCardAnswer || !Number.isFinite(n)) return n;
			const q = this.findSmallQuestionByNum(n);
			const selected = q && q.selected !== undefined && q.selected !== null ? String(q.selected).trim() : '';
			return selected || n;
		},
		toggleCardAnswerDisplay() {
			this.showCardAnswer = !this.showCardAnswer;
		},
		getCardItemClass(num) {
			return {
				active: Number(num) === Number(this.activeQuestionNum),
				answered: this.isQuestionAnswered(num),
				disabled: !this.isQuestionNavigable(num)
			};
		},
		handleCardClick(num) {
			const n = Number(num);
			if (!Number.isFinite(n)) return;
			if (!this.isQuestionNavigable(n)) {
				if (this.$message) {
					console.log('请等待音频播放到题目后再切换')
				}
				return;
			}
			const unlockedMax = Number(this.maxUnlockedQuestionNum);
			const r = this.getNavigableRangeByAudioNode(this.getCurrentAudioNode());
			const inCurrentRange = !!(r && n >= Number(r.min) && n <= Number(r.max));
			
			// 如果点击的是已解锁但不在当前音频范围内的题目，需要切换到对应节点
			if (Number.isFinite(unlockedMax) && unlockedMax > 0 && n <= unlockedMax && !inCurrentRange) {
				this.autoFollowAudioNode = false;
				// 强制更新到对应的节点以显示题目
				const node = this.getNodeByQuestionNum(n);
				if (node !== null) {
					this.examNodeCurrent = node;
				}
			} else {
				this.autoFollowAudioNode = true;
				this.lastAutoFollowAudioNode = this.getCurrentAudioNode();
				const node = this.getNodeByQuestionNum(n);
				if (node !== null) {
					this.examNodeCurrent = node;
				}
			}
			
			this.activeQuestionNum = n;
			this.$nextTick(() => {
				this.scrollToQuestion(n);
			});
		},
		scrollToQuestion(num) {
			const id = this.getQuestionAnchorId(num);
			if (!id) return;
			const el = document.getElementById(id);
			if (!el) return;
			if (typeof el.scrollIntoView === 'function') {
				el.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		},
		bindAudioEvents() {
			if (!this.$audio || !this.$audio.audio) return;
			if (this._audioEventHandlers) return;
			const audio = this.$audio.audio;
			const onPlay = () => {
				this.isAudioPlaying = true;
				this.startWave();
			};
			const onPause = () => {
				this.isAudioPlaying = false;
				this.stopWave();
			};
			const onEnded = () => {
				this.isAudioPlaying = false;
				this.stopWave();
				// 播放完成回调在 playSrc 中处理
			};
			audio.addEventListener('play', onPlay);
			audio.addEventListener('pause', onPause);
			audio.addEventListener('ended', onEnded);
			this._audioEventHandlers = { onPlay, onPause, onEnded };
		},
		unbindAudioEvents() {
			if (!this.$audio || !this.$audio.audio) {
				this._audioEventHandlers = null;
				return;
			}
			if (!this._audioEventHandlers) return;
			const audio = this.$audio.audio;
			const { onPlay, onPause, onEnded } = this._audioEventHandlers;
			audio.removeEventListener('play', onPlay);
			audio.removeEventListener('pause', onPause);
			audio.removeEventListener('ended', onEnded);
			this._audioEventHandlers = null;
		},
		ensureAudioVisualizer() {
			const ga = this.$audio;
			if (!ga || !ga.audio) return null;
			if (ga._webaudioViz && ga._webaudioViz.audio === ga.audio) return ga._webaudioViz;
			const AudioCtx = window.AudioContext || window.webkitAudioContext;
			if (!AudioCtx) return null;
			try {
				const ctx = new AudioCtx();
				const source = ctx.createMediaElementSource(ga.audio);
				const analyser = ctx.createAnalyser();
				analyser.fftSize = 1024;
				analyser.smoothingTimeConstant = 0.7;
				source.connect(analyser);
				analyser.connect(ctx.destination);
				ga._webaudioViz = { ctx, source, analyser, audio: ga.audio };
				return ga._webaudioViz;
			} catch (e) {
				console.warn('Web Audio API initialization failed (likely CORS):', e.message);
				return ga._webaudioViz && ga._webaudioViz.analyser ? ga._webaudioViz : null;
			}
		},
		bindWaveResizeObserver() {
			const w = this._wave;
			if (!w) return;
			this.unbindWaveResizeObserver();
			const el = this.$refs.waveWrap;
			if (!el) return;
			if (typeof ResizeObserver !== 'undefined') {
				w.ro = new ResizeObserver(() => {
					this.ensureWaveCanvasSize();
					if (!this.isAudioPlaying) {
						this.drawWaveIdle();
					}
				});
				w.ro.observe(el);
				return;
			}
			w.onResize = () => {
				this.ensureWaveCanvasSize();
				if (!this.isAudioPlaying) {
					this.drawWaveIdle();
				}
			};
			window.addEventListener('resize', w.onResize);
		},
		unbindWaveResizeObserver() {
			const w = this._wave;
			if (!w) return;
			if (w.ro) {
				try {
					w.ro.disconnect();
				} catch (e) { }
				w.ro = null;
			}
			if (w.onResize) {
				window.removeEventListener('resize', w.onResize);
				w.onResize = null;
			}
		},
		ensureWaveCanvasSize() {
			const w = this._wave;
			if (!w) return;
			const wrap = this.$refs.waveWrap;
			const canvas = this.$refs.waveCanvas;
			if (!wrap || !canvas) return;
			const rect = wrap.getBoundingClientRect();
			const cssW = Math.max(1, Math.floor(rect.width));
			const cssH = Math.max(1, Math.floor(rect.height));
			const dpr = Math.max(1, Math.floor((window.devicePixelRatio || 1) * 100) / 100);
			if (cssW === w.cssW && cssH === w.cssH && dpr === w.dpr && canvas.width && canvas.height) return;
			w.cssW = cssW;
			w.cssH = cssH;
			w.dpr = dpr;
			canvas.width = Math.max(1, Math.floor(cssW * dpr));
			canvas.height = Math.max(1, Math.floor(cssH * dpr));
			canvas.style.width = `${cssW}px`;
			canvas.style.height = `${cssH}px`;
			const ctx2d = canvas.getContext('2d');
			w.ctx2d = ctx2d;
			if (ctx2d) {
				ctx2d.setTransform(dpr, 0, 0, dpr, 0, 0);
			}
		},
		startWave() {
			const w = this._wave;
			if (!w) return;
			const canvas = this.$refs.waveCanvas;
			const wrap = this.$refs.waveWrap;
			if (!canvas || !wrap) {
				w.pendingStart = true;
				return;
			}
			w.pendingStart = false;
			this.bindWaveResizeObserver();
			this.ensureWaveCanvasSize();
			
			// 尝试初始化 Web Audio API
			const viz = this.ensureAudioVisualizer();
			if (viz && viz.ctx && viz.ctx.state === 'suspended') {
				const p = viz.ctx.resume();
				if (p && typeof p.catch === 'function') {
					p.catch(() => { });
				}
			}
			
			if (w.running) return;
			w.running = true;
			const tick = () => {
				if (!w.running) return;
				this.drawWaveFrame();
				w.rafId = requestAnimationFrame(tick);
			};
			w.rafId = requestAnimationFrame(tick);
		},
		stopWave() {
			const w = this._wave;
			if (!w) return;
			w.pendingStart = false;
			w.running = false;
			if (w.rafId) {
				cancelAnimationFrame(w.rafId);
				w.rafId = null;
			}
			this.drawWaveIdle();
		},
		drawWaveIdle() {
			const w = this._wave;
			if (!w || !w.ctx2d) return;
			const ctx = w.ctx2d;
			const width = w.cssW || 0;
			const height = w.cssH || 0;
			if (!width || !height) return;
			ctx.clearRect(0, 0, width, height);
			const barW = 2;
			const gap = 3;
			const step = barW + gap;
			const count = Math.max(1, Math.min(160, Math.floor(width / step)));
			const total = count * step - gap;
			const x0 = Math.max(0, (width - total) / 2);
			ctx.fillStyle = 'rgba(255,255,255,0.35)';
			const base = Math.max(2, Math.floor(height * 0.18));
			for (let i = 0; i < count; i++) {
				const x = x0 + i * step;
				const h = base;
				const y = Math.floor((height - h) / 2);
				ctx.fillRect(x, y, barW, h);
			}
		},
		drawWaveFallback() {
			const w = this._wave;
			if (!w || !w.ctx2d) return;
			const ctx = w.ctx2d;
			const width = w.cssW || 0;
			const height = w.cssH || 0;
			if (!width || !height) return;
			ctx.clearRect(0, 0, width, height);
			const barW = 2;
			const gap = 3;
			const step = barW + gap;
			const count = Math.max(1, Math.min(160, Math.floor(width / step)));
			const total = count * step - gap;
			const x0 = Math.max(0, (width - total) / 2);
			const base = Math.max(2, Math.floor(height * 0.18));
			const amp = Math.max(1, Math.floor(height * 0.1));
			const t = Date.now() / 1000;
			ctx.fillStyle = 'rgba(255,255,255,0.35)';
			for (let i = 0; i < count; i++) {
				const phase = (i / count) * Math.PI * 2;
				const hh = Math.max(2, base + Math.floor(Math.sin(t * 2 + phase) * amp));
				const x = x0 + i * step;
				const y = Math.floor((height - hh) / 2);
				ctx.fillRect(x, y, barW, hh);
			}
		},
		drawWaveFrame() {
			const w = this._wave;
			if (!w) return;
			const canvas = this.$refs.waveCanvas;
			const wrap = this.$refs.waveWrap;
			if (!canvas || !wrap) return;
			if (!w.ctx2d) {
				this.ensureWaveCanvasSize();
			}
			const ctx = w.ctx2d;
			const width = w.cssW || 0;
			const height = w.cssH || 0;
			if (!ctx || !width || !height) return;
			
			// 尝试使用真实音频数据，如果失败则使用回退动画
			const viz = this.ensureAudioVisualizer();
			if (!viz || !viz.analyser) {
				this.drawWaveFallback();
				return;
			}
			const analyser = viz.analyser;
			if (!w.timeData || w.timeData.length !== analyser.fftSize) {
				w.timeData = new Uint8Array(analyser.fftSize);
			}
			if (!w.freqData || w.freqData.length !== analyser.frequencyBinCount) {
				w.freqData = new Uint8Array(analyser.frequencyBinCount);
			}
			analyser.getByteTimeDomainData(w.timeData);
			let sum = 0;
			for (let i = 0; i < w.timeData.length; i++) {
				const v = (w.timeData[i] - 128) / 128;
				sum += v * v;
			}
			let rms = Math.sqrt(sum / w.timeData.length);
			if (!Number.isFinite(rms)) rms = 0;
			w.rmsSmoothed = w.rmsSmoothed ? w.rmsSmoothed * 0.82 + rms * 0.18 : rms;
			analyser.getByteFrequencyData(w.freqData);
			let maxFreq = 0;
			for (let i = 0; i < w.freqData.length; i++) {
				if (w.freqData[i] > maxFreq) maxFreq = w.freqData[i];
			}
			if (maxFreq === 0) {
				this.drawWaveFallback();
				return;
			}
			ctx.clearRect(0, 0, width, height);
			const barW = 2;
			const gap = 3;
			const step = barW + gap;
			const count = Math.max(1, Math.min(160, Math.floor(width / step)));
			const total = count * step - gap;
			const x0 = Math.max(0, (width - total) / 2);
			const minH = Math.max(2, Math.floor(height * 0.08));
			const loud = Math.min(1, Math.max(0, w.rmsSmoothed * 5.5));
			const scale = 0.12 + loud * 1.1;
			const freqLen = w.freqData.length;
			const freqEnd = Math.max(1, Math.floor(freqLen * 0.72));
			ctx.fillStyle = `rgba(255,255,255,${0.55 + loud * 0.35})`;
			for (let i = 0; i < count; i++) {
				const bin = Math.min(freqEnd - 1, Math.floor((i / count) * freqEnd));
				const n = w.freqData[bin] / 255;
				const v = Math.pow(n, 0.5);
				const hh = minH + (height - minH) * Math.min(1, v * 1.9 * scale);
				const h = Math.max(2, Math.floor(hh));
				const x = x0 + i * step;
				const y = Math.floor((height - h) / 2);
				ctx.fillRect(x, y, barW, h);
			}
		},

		isAutoplayBlockedError(e) {
			if (!e) return false;
			if (e.name === 'NotAllowedError') return true;
			const msg = String(e.message || '').toLowerCase();
			return msg.includes('play() failed because the user didn\'t interact') || msg.includes('user didn\'t interact');
		},
		bindAutoplayUnlock(src, ended) {
			this._pendingAutoplaySrc = src;
			this._pendingAutoplayEnded = typeof ended === 'function' ? ended : null;
			if (this._autoplayUnlockFn) return;
			this._autoplayUnlockFn = () => {
				const retrySrc = this._pendingAutoplaySrc;
				const retryEnded = this._pendingAutoplayEnded;
				this._pendingAutoplaySrc = null;
				this._pendingAutoplayEnded = null;
				this.unbindAutoplayUnlock();
				if (retrySrc) {
					this.playSrc(retrySrc, retryEnded);
				}
			};
			window.addEventListener('click', this._autoplayUnlockFn, { once: true });
			window.addEventListener('keydown', this._autoplayUnlockFn, { once: true });
			if (!this._autoplayUnlockNotified && this.$message) {
				this._autoplayUnlockNotified = true;
				this.$message.warning('浏览器限制自动播放，请点击页面任意位置后再播放');
				console.log('浏览器限制自动播放，请点击页面任意位置后再播放')
			}
		},
		unbindAutoplayUnlock() {
			if (!this._autoplayUnlockFn) return;
			window.removeEventListener('click', this._autoplayUnlockFn);
			window.removeEventListener('keydown', this._autoplayUnlockFn);
			this._autoplayUnlockFn = null;
		},
		handleVolumeChange(val) {
			const volume = Math.max(0, Math.min(100, Number(val)));
			this.volume = volume;
			try {
				window.localStorage.setItem(AUDIO_VOLUME_STORAGE_KEY, String(volume));
			} catch (e) {}
			if (this.$audio && typeof this.$audio.playvolume === 'function') {
				this.$audio.playvolume(volume / 100);
			}
		},
		getSavedVolume() {
			try {
				const raw = window.localStorage.getItem(AUDIO_VOLUME_STORAGE_KEY);
				if (raw === null || raw === '') return null;
				const volume = Math.max(0, Math.min(100, Number(raw)));
				return Number.isFinite(volume) ? volume : null;
			} catch (e) {
				return null;
			}
		},
		getSeatNumber() {
			try {
				const raw = window.localStorage.getItem(SEAT_NUMBER_STORAGE_KEY);
				if (raw === null || raw === '') return null;
				this.seatNumber = Number(raw);
			} catch (e) {
				return 1;
			}
		},
		syncSavedVolume() {
			const savedVolume = this.getSavedVolume();
			if (savedVolume === null) return;
			this.volume = savedVolume;
		},
		async playSrc(src, ended) {
			if (!this.$audio || !this.$audio.audio) return;
			const audio = this.$audio.audio;
			
			// 设置 crossOrigin 属性以支持 CORS
			if (!audio.crossOrigin) {
				audio.crossOrigin = 'anonymous';
			}
			
			audio.onended = typeof ended === 'function' ? ended : null;
			
			// 如果是外部链接且需要避免 CORS，可以尝试通过 fetch 下载
			// 注意：这会增加加载时间和内存占用
			let finalSrc = src;
			if (this.shouldUseBlobUrl(src)) {
				try {
					const blobUrl = await this.fetchAudioAsBlob(src);
					if (blobUrl) {
						finalSrc = blobUrl;
					}
				} catch (e) {
					console.warn('Failed to fetch audio as blob, using original URL:', e);
				}
			}
			
			audio.src = finalSrc;
			audio.currentTime = 0;
			this.handleVolumeChange(this.volume);
			const p = audio.play();
			if (p && typeof p.catch === 'function') {
				p.catch((e) => {
					if (this.isAutoplayBlockedError(e)) {
						this.bindAutoplayUnlock(finalSrc, ended);
					} else if (e && e.name !== 'AbortError') {
						console.warn('Audio playback failed:', e);
					}
				});
			}
		},
		shouldUseBlobUrl(url) {
			// 只在需要真实音频数据时（调试模式）才使用 blob
			// 这样可以避免不必要的下载
			return false; // 默认关闭，如果 crossOrigin 不够再启用
		},
		async fetchAudioAsBlob(url) {
			try {
				const response = await fetch(url, {
					mode: 'cors',
					credentials: 'omit'
				});
				if (!response.ok) return null;
				const blob = await response.blob();
				return URL.createObjectURL(blob);
			} catch (e) {
				return null;
			}
		},
		playAudioList(list, index, done) {
			const srcList = Array.isArray(list) ? list : [];
			const i = Number(index) || 0;
			if (i >= srcList.length) {
				this.stopCountDown();
				if (typeof done === 'function') done();
				return;
			}
			// 绑定音频事件以触发波形动画
			this.bindAudioEvents();
			
			this.playSrc(srcList[i], () => {
				this.playAudioList(srcList, i + 1, done);
			});
		},
		startNoticeFlow() {
			console.log('[jikao] startNoticeFlow 被调用');
			this.showNotice = true;
			
			const loading = this.$loading ? this.$loading(this.$pre) : null;
			
			this.confirmExam(1)
				.finally(() => {
					if (loading && typeof loading.close === 'function') {
						loading.close();
					}
					
					// 使用获取的音频列表或备用音频
					const audioList = this.confirmAudioList && this.confirmAudioList.length 
						? this.confirmAudioList 
						: [require('@/assets/mnjk/zhuyishixiang.mp3')];
					
					// 在播放注意事项音频时，预加载A卷和B卷的试卷信息
					this.preloadPapers();
					
					// 播放音频列表，完成后启动考试流程
					this.playAudioList(audioList, 0, () => {
						this.showNotice = false;
						this.startExamAudio();
					});
				});
		},
		preloadPapers() {
			// 预加载A卷和B卷的试卷信息
			Promise.all([
				this.requestConfirmExam(2), // A卷 nodeType=2
				this.requestConfirmExam(3)  // B卷 nodeType=3
			]).then(() => {
				console.log('A卷和B卷试卷信息预加载完成');
			}).catch((err) => {
				console.warn('预加载试卷信息失败:', err);
			});
		},
		startExamAudio() {
			this.isExamFinished = false;
			this.isEndPage = false;
			this.resetAutoSubmitState();
			const p = this.setPaper('A');
			Promise.resolve(p).finally(() => {
				this.playCurrentPaperAudio();
			});
		},
		handleDebugPaperChange(val) {
			const p = this.setPaper(val, { resetAudioState: true });
			Promise.resolve(p).finally(() => {
				this.playCurrentPaperAudio();
			});
		},
		handleDebugAudioChange(val) {
			this.playAudioByIndex(val);
		},
		formatDebugTooltip(val) {
			return `音频 ${val + 1}`;
		},
		handleDebugEndExam() {
			this.ensurePaperConfigs();
			const paperA = this._papers && this._papers.A ? this._papers.A.exam : (this.currentPaper === 'A' ? this.exam : []);
			const paperB = this._papers && this._papers.B ? this._papers.B.exam : (this.currentPaper === 'B' ? this.exam : []);
			const debugData = {
				...(this.examQuery || {}),
				paperA,
				paperB
			};
			console.log('【结束考试(调试)】debugData =', JSON.stringify(debugData));
		},
		stopAudio() {
			this.stopWave();
			this.unbindWaveResizeObserver();
			this.unbindAudioEvents();
			this._pendingAutoplaySrc = null;
			this._pendingAutoplayEnded = null;
			this.unbindAutoplayUnlock();
			this.stopCountDown();
			this.isAudioPlaying = false;
			this.currentAudioIndex = 0;
			if (!this.$audio) return;
			if (this.$audio.audio) {
				this.$audio.audio.onended = null;
			}
			if (typeof this.$audio.pause === 'function') {
				this.$audio.pause();
			}
			if (typeof this.$audio.resetFn === 'function') {
				this.$audio.resetFn();
			}
		},
		startCountDown() {
			// 清除之前的定时器
			this.stopCountDown();
			
			if (!this.$audio || !this.$audio.audio) return;
			
			const audio = this.$audio.audio;
			
			// 等待音频元数据加载完成
			const updateCountDown = () => {
				if (!audio || audio.readyState < 1) return;
				
				const duration = audio.duration;
				const currentTime = audio.currentTime;
				
				if (!Number.isFinite(duration) || !Number.isFinite(currentTime)) {
					this.countDown = '-1';
					return;
				}
				
				const remaining = Math.max(0, duration - currentTime);
				this.remaining = Math.ceil(remaining);
				const seconds = Math.floor(remaining);
				
				this.countDown = `${seconds}`;
			};
			
			// 如果音频已经加载，立即更新一次
			if (audio.readyState >= 1) {
				updateCountDown();
			}
			
			// 监听元数据加载事件
			const onLoadedMetadata = () => {
				updateCountDown();
			};
			audio.addEventListener('loadedmetadata', onLoadedMetadata);
			
			// 定时更新倒计时
			this._countDownTimer = setInterval(() => {
				updateCountDown();
			}, 100);
			
			// 保存事件处理器以便清理
			this._countDownCleanup = () => {
				audio.removeEventListener('loadedmetadata', onLoadedMetadata);
			};
		},
		stopCountDown() {
			if (this._countDownTimer) {
				clearInterval(this._countDownTimer);
				this._countDownTimer = null;
			}
			if (this._countDownCleanup) {
				this._countDownCleanup();
				this._countDownCleanup = null;
			}
			this.countDown = '-1';
		}
	}
};
</script>

<style lang="scss" scoped>
.jikao-container {
	display: flex;
	justify-content: center;
	height: 100vh;
	background-color: #f0f2f5;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

	.inner-container {
		display: flex;
		width: 1200px;
		height: 100%;
		background-color: #fff;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
	}
}

/* Left Content Styles */
.main-content-wrapper {
	flex: 1;
	display: flex;
	flex-direction: column;
	position: relative;

	.exam-wrapper {
		flex: 1;
		display: flex;
		flex-direction: column;
		position: relative;
		padding: 40px 60px;
		overflow-y: auto;
		min-height: 0;
	}

	/* 注意事项模块样式 */
	.zhuyishixiang-container {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0;
	}

	.content-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}

	.notice-box {
		background-color: #f0faff;
		border-radius: 10px;
		padding: 40px 60px;
		width: 100%;
		max-width: 800px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
		text-align: center;

		.notice-title {
			color: #f56c6c;
			font-size: 24px;
			font-weight: bold;
			margin-bottom: 30px;
			letter-spacing: 2px;
		}

		.notice-content {
			text-align: left;
			margin-bottom: 30px;

			p {
				color: #409EFF;
				font-size: 16px;
				line-height: 1.8;
				margin-bottom: 15px;
				text-indent: 0;
			}
		}

		.notice-footer {
			color: #409EFF;
			font-size: 20px;
			font-weight: bold;
			letter-spacing: 1px;
		}
	}

	.exam-header {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 20px 60px;

		.exam-title-card {
			width: 100%;
			max-width: 980px;
			min-height: 230px;
			background: #f0fdff;
			border-radius: 16px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: 20px 30px;
			box-sizing: border-box;
		}

		.exam-title {
			font-size: 34px;
			line-height: 1.2;
			font-weight: bold;
			color: #0080ff;
			margin-bottom: 14px;
		}

		.exam-subtitle {
			font-size: 34px;
			line-height: 1.2;
			font-weight: bold;
			color: #0080ff;
		}
	}

	.section-content {
		flex: 1;
		display: flex;
		flex-direction: column;


		.section-title {
			font-size: 24px;
			font-weight: bold;
			color: #000;
			margin-bottom: 20px;
			flex-shrink: 0;
		}

		.instruction-box {
			background-color: #e6f3ff;
			border-radius: 8px;
			padding: 20px;
			font-size: 16px;
			line-height: 1.6;
			color: #333;
			text-align: justify;
			margin-bottom: 30px;
			flex-shrink: 0;
		}

		.prompt-box {
			padding: 15px 20px;
			font-weight: bold;
			font-size: 16px;
			color: #000;
			background-color: #fff;
			align-self: flex-start;
			margin-bottom: 20px;
		}

		.kaoshiH {
			margin-bottom: 40px;
		}

		.kaoshiT {
			margin-bottom: 44px;
			scroll-margin-top: 20px;

			&.is-active-question {
				outline: 2px solid #0080ff;
				outline-offset: 6px;
				border-radius: 6px;
			}

			.kaoshiXx {
				padding-left: 102px;

				p {
					margin-bottom: 36px;
					font-size: 18px;
					cursor: pointer;

					&:hover {
						color: #1d7b3a;
					}

					&:last-of-type {
						margin-bottom: 0;
					}
				}

				.active {
					color: #1d7b3a;
				}
			}

			.kaoshiWt {
				display: flex;
				font-weight: bold;
				margin-bottom: 36px;

				.kaoshiDa {
					width: 72px;
					margin-right: 30px;
					position: relative;
					display: flex;
					justify-content: space-between;
					line-height: 1.2;

					span {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}
		}

		.question-list {
			.question-item {
				margin-bottom: 30px;

				.question-header {
					display: flex;
					align-items: center;
					margin-bottom: 15px;
					font-size: 18px;
					font-weight: bold;
					color: #333;

					.answer-box {
						min-width: 40px;
						display: inline-flex;
						justify-content: center;
						margin-right: 15px;
						color: #0080ff;
						font-family: monospace;
					}
				}

				.options-list {
					padding-left: 60px;

					.option-item {
						margin-bottom: 10px;
						font-size: 16px;
						color: #666;
					}
				}
			}
		}
	}

	.bottom-bar {
		height: 60px;
		background-color: #0080ff;
		display: flex;
		align-items: center;
		padding: 0 150px;
		color: #fff;
		position: relative;
		overflow: hidden;

		.debug-toggle {
			position: absolute;
			top: 2px;
			right: 2px;
			width: 20px;
			height: 20px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			z-index: 100;
			opacity: 0.5;
			transition: all 0.2s;

			&:hover {
				opacity: 1;
				transform: scale(1.1);
			}

			i {
				font-size: 14px;
				color: #fff;
			}
		}

		.indicate-box {
			display: flex;
			align-items: center;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			width: 150px;
			display: flex;
			align-items: center;

			.indicate-light {
				width: 10px;
				height: 10px;
				background-color: #00FF08;
				border-radius: 50%;
				margin-left: auto;

				&.is-red {
					background-color: #FF3B30;
				}
			}
			.indicate-text-box {
				width: 100px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: bold;
				font-size: 22px;
				color: #FFFFFF;
				line-height: 22px;
				text-align: center;
			}
		}

		.count-down {
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			width: 60px;
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 100;
		}

		.status-indicator {
			display: flex;
			align-items: center;
			margin-right: 20px;
			flex-shrink: 0;

			.dot {
				width: 10px;
				height: 10px;
				background-color: #67c23a;
				border-radius: 50%;
				margin-right: 10px;
				box-shadow: 0 0 4px rgba(255, 255, 255, 0.5);
			}

			.status-text {
				font-size: 18px;
				font-weight: bold;
			}
		}

		.dotted-line {
			flex: 1;
			height: 0;
			border-bottom: 2px dotted rgba(255, 255, 255, 0.6);
			margin-top: 5px;
		}

		.audio-wave {
			flex: 1;
			height: 20px;
			display: flex;
			align-items: center;
			min-width: 0;
			/* 让波形始终占据空间 */
			width: 100%;
		}

		.audio-wave-canvas {
			width: 100%;
			height: 20px;
			display: block;
		}

		.debug-panel {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: #0080ff;
			/* 遮盖底部背景 */
			z-index: 50;
			/* 确保在波形之上 */

			display: flex;
			flex-direction: column;
			justify-content: center;
			padding: 0 40px;
			/* 避开右侧开关 */
			box-sizing: border-box;

			.debug-controls {
				display: flex;
				align-items: center;
				margin-bottom: 2px;

				.debug-end-btn {
					margin-left: 12px;
				}

				.el-radio-button__inner {
					padding: 5px 10px;
				}

				.node-info {
					margin-left: 15px;
					font-size: 12px;
					color: rgba(255, 255, 255, 0.9);
					display: flex;
					align-items: center;
					overflow: hidden;

					.node-id {
						background: rgba(0, 0, 0, 0.2);
						padding: 0 4px;
						border-radius: 2px;
						margin-right: 6px;
						font-family: monospace;
					}

					.node-label {
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						max-width: 300px;
					}
				}
			}

			.debug-slider-row {
				display: flex;
				align-items: center;

				.time-label {
					font-size: 12px;
					font-family: monospace;
					margin-right: 10px;
					min-width: 50px;
					text-align: right;
				}

				.debug-slider {
					flex: 1;
					width: 0;
					/* fix flex layout issue */

					::v-deep .el-slider__runway {
						margin: 8px 0;
						background-color: rgba(255, 255, 255, 0.3);
						height: 4px;
					}

					::v-deep .el-slider__bar {
						background-color: #fff;
						height: 4px;
					}

					::v-deep .el-slider__button-wrapper {
						top: -16px;
					}

					::v-deep .el-slider__button {
						border-color: #fff;
						width: 10px;
						height: 10px;
					}
				}
			}
		}

		.audio-debug {
			flex: 1;
			display: flex;
			align-items: center;
			min-width: 0;
		}

		.audio-debug-meta {
			margin-right: 12px;
			flex-shrink: 0;
			text-align: right;
		}

		.audio-debug-node {
			font-size: 12px;
			line-height: 1.2;
			opacity: 0.9;
			max-width: 140px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.audio-debug-time {
			font-size: 12px;
			line-height: 1.2;
			font-family: monospace;
			opacity: 0.9;
		}

		.audio-debug-slider {
			flex: 1;
			min-width: 0;
		}
	}
}

/* Right Sidebar Styles */
.sidebar {
	width: 300px;
	background-color: #e9f6ff;
	padding: 34px 25px 0;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;

	.sidebar-header {
		display: flex;
		justify-content: space-between;
		margin-bottom: 15px;

		.header-item {
			flex: 1;
			text-align: center;

			.label {
				font-size: 19px;
				line-height: 1;
				font-weight: bold;
				color: #000;
				letter-spacing: 6px;
			}
		}
	}

	.user-seat-panel {
		display: flex;
		margin: 0 auto 26px;

		.seat-box {
			width: 125px;
			height: 125px;
			border: 1px solid #bfc6d1;
			box-sizing: border-box;
			background-color: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.avatar-box {
			border-right: none;
		}

		.seat-avatar-img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		.seat-avatar-placeholder {
			font-size: 78px;
			color: #c4c4c4;
			line-height: 1;
		}

		.seat-number {
			font-size: 62px;
			font-weight: 500;
			line-height: 1;
			color: #0080ff;
			font-family: Arial, sans-serif;
		}
	}

	.user-info {
		margin-bottom: 20px;

		.info-group {
			margin-bottom: 16px;

			.info-label {
				font-size: 13px;
				line-height: 1.1;
				color: #575757;
				margin-bottom: 8px;
				letter-spacing: 2px;
			}

			.info-value {
				font-size: 13px;
				line-height: 1.2;
				color: #0080ff;
				font-weight: bold;
				letter-spacing: 1px;

				&.ticket {
					font-family: Arial, sans-serif;
				}
			}
		}

		.info-divider {
			border-top: 1px solid #b8c7d8;
			margin-top: 26px;
		}
	}

	/* Question Card Styles */
	.question-card {
		background-color: #fff;
		border-radius: 8px;
		padding: 20px 10px 20px 20px;
		flex: 1;
		/* Fill remaining height */
		display: flex;
		flex-direction: column;
		min-height: 0;
		/* Important for nested scrolling */
		margin-bottom: 20px;
		/* Space before volume control */
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

		.card-content {
			flex: 1;
			overflow-y: auto;
			// padding-right: 5px;
			/* Prevent scrollbar overlapping content slightly */

			/* Custom scrollbar for webkit */
			&::-webkit-scrollbar {
				width: 6px;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #dcdfe6;
				border-radius: 3px;
			}

			&::-webkit-scrollbar-track {
				background-color: #f5f7fa;
			}
		}

		.section-group {
			margin-bottom: 20px;

			.section-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 10px;

				.section-name {
					font-weight: bold;
					font-size: 14px;
					color: #333;
				}

				.show-answer {
					font-size: 12px;
					color: #666;
					cursor: pointer;
					display: flex;
					align-items: center;
					margin-right: 10px;


					i {
						margin-right: 4px;
					}
				}
			}

			.question-grid {
				display: flex;
				flex-wrap: wrap;
				gap: 10px;

				.question-item {
					width: 32px;
					height: 32px;
					border: 1px solid #f56c6c;
					border-radius: 4px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 14px;
					color: #f56c6c;
					cursor: pointer;

					&:hover {
						border-color: #0080ff;
						color: #0080ff;
					}

					&.answered {
						background-color: #0080ff;
						border-color: #0080ff;
						color: #fff;
					}

					&.disabled {
						cursor: not-allowed;
						opacity: 0.45;

						&:hover {
							border-color: #f56c6c;
							color: #f56c6c;
						}
					}

				}
			}
		}

		.card-footer {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 20px;
			padding-top: 15px;
			border-top: 1px solid #f0f0f0;

			.paper-type {
				font-size: 18px;
				font-weight: bold;
				color: #0080ff;
			}

			.status-text {
				font-size: 16px;
				color: #0080ff;
				display: flex;
				align-items: center;

				i {
					margin-top: 3px;
					margin-right: 4px;
					font-size: 20px;
				}
			}
		}
	}

	.volume-control {
		border-top: 1px solid #d0e0f0;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-top: auto;

		.volume-label {
			position: absolute;
			top: 0;
			left: 50%;
			transform: translate(-50%, -50%);
			background-color: #e6f3ff;
			padding: 0 10px;
			color: #666;
			font-size: 14px;
		}

		.slider-wrapper {
			display: flex;
			align-items: center;
			width: 100%;
			padding: 0 10px;

			.volume-icon {
				font-size: 24px;
				margin-right: 15px;
				color: #333;
				width: 30px;
				height: 30px;
			}

			.el-slider {
				flex: 1;
			}
		}
	}
}

/* Floating Step Control Styles */
.floating-step-control {
	position: fixed;
	left: 20px;
	bottom: 20px;
	z-index: 9999;
	display: flex;
	flex-direction: column-reverse;
	align-items: flex-start;

	.step-toggle-btn {
		width: 40px;
		height: 40px;
		background-color: #0080ff;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		box-shadow: 0 2px 10px rgba(0, 128, 255, 0.4);
		transition: all 0.3s;
		z-index: 10001;

		&:hover {
			transform: scale(1.1);
			background-color: #0066cc;
		}
	}

	.step-panel-content {
		background-color: rgba(0, 0, 0, 0.7);
		border-radius: 8px;
		padding: 10px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		width: 300px;
		max-height: 400px;
		overflow-y: auto;
		backdrop-filter: blur(5px);
		margin-bottom: 15px;
		/* Space between content and toggle button */
		transform-origin: bottom left;

		/* Scrollbar styling */
		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-thumb {
			background-color: rgba(255, 255, 255, 0.3);
			border-radius: 2px;
		}

		.step-panel-header {
			color: #fff;
			font-size: 14px;
			font-weight: bold;
			margin-bottom: 10px;
			padding-bottom: 5px;
			border-bottom: 1px solid rgba(255, 255, 255, 0.2);
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.step-list {
			display: flex;
			flex-wrap: wrap;
			gap: 8px;

			.step-item {
				padding: 6px 12px;
				background-color: rgba(255, 255, 255, 0.2);
				border: 1px solid rgba(255, 255, 255, 0.3);
				border-radius: 4px;
				cursor: pointer;
				font-size: 12px;
				color: #fff;
				transition: all 0.2s;
				white-space: nowrap;

				&:hover {
					background-color: rgba(255, 255, 255, 0.3);
				}

				&.active {
					background-color: #0080ff;
					border-color: #0080ff;
					color: #fff;
					font-weight: bold;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
				}
			}
		}
	}
}

/* Transition effects */
.fade-enter-active,
.fade-leave-active {
	transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
	transform: translateY(20px) scale(0.9);
}

</style>
